export default {
	contract: [],
	contractID: null,
	TotalRecords: 0,
	detailContract:[]
}
